import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import { user_profile_url } from 'mk/urls/functions';
import * as React from 'react';

const MENTION_RE = /(?:\s|^)@([a-zA-Z0-9.][a-zA-Z0-9._]+)/;

export const mentionize = (text: TextLike) => reactFilter(text, (s: string): React.ReactChild[] => {
    const ret = [];

    const matcher = new RegExp(MENTION_RE, 'g');
    let from = 0;
    while (true) {
        // calling matcher repeatadly moves it through the whole string 's'
        const match = matcher.exec(s);
        if (match) {
            const username = match[1].toLowerCase();
            const to = matcher.lastIndex - username.length - 1;

            // copy text before current mention (empty string are removed by reactFilter)
            ret.push(s.substring(from, to));

            // replace @username with link
            const profileUrl = user_profile_url(username);
            ret.push(<span className="mention">@<a href={profileUrl}>{username}</a></span>);

            from = matcher.lastIndex;
        } else {
            // copy text after last mention
            ret.push(s.substring(from));
            break;
        }
    }

    return ret;
});
